import { RuMaterialTypeEnum } from '@features/guidbooks/types';
import { RuMaterialParametrs } from '../types';
export var formatMaterial = function (material) {
    var _a, _b;
    console.log(material);
    var materialType = (_a = RuMaterialTypeEnum[material.materialType]) !== null && _a !== void 0 ? _a : material.materialType;
    console.log(materialType);
    var materialParams = ((_b = material.materialTypeValue) === null || _b === void 0 ? void 0 : _b.map(function (val) {
        var _a;
        console.log(val);
        var param = (_a = RuMaterialParametrs[val.materialParametrs]) !== null && _a !== void 0 ? _a : val.materialParametrs;
        return "".concat(param, ": ").concat(val.value);
    }).join(', ')) || 'нет данных';
    return "".concat(materialType, " (").concat(materialParams, ")");
};
